import { Alert } from '@mui/material'
import React, { useContext } from 'react'
import PrimaryButton from '../buttons/PrimaryButton'
import { useTranslation } from 'react-i18next'
import UserContext from '../contexts/UserContext'
import PageTitleText from '../texts/PageTitleText'
import PageTitleCard from '../cards/PageTitleCard'
import PageContainer from '../containers/PageContainer'
import ResponsiveModal from '../modal/ResponsiveModal'
import CreateVenueForm from './CreateVenueForm'

type Props = {
    onCreated: () => void;
}

const MozrestInfo = (props: Props) => {
    const { t } = useTranslation();
    const { hasFeature } = useContext(UserContext);
    const [showCreateVenue, setShowCreateVenue] = React.useState(false);

    function onCreated(){
        setShowCreateVenue(false);
        props.onCreated();
    }

    return (
        <>
            <PageContainer>
                <PageTitleCard>
                    <PageTitleText>
                        {t("navigation.mozrest")}
                    </PageTitleText>
                </PageTitleCard>
                <div className="pt-4">
                    <div className="bg-secondary-light bg-opacity-20 grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div className="p-3">
                            <div className="text-[17px] font-bold">
                                {t("menu.listing_manager_info.summary")}
                            </div>
                            <div className="my-2">
                                <ul className="pl-4 list-disc text-[16px]">
                                    <li>
                                        {t("menu.listing_manager_info.bullet_1")}
                                    </li>
                                    <li>
                                        {t("menu.listing_manager_info.bullet_2")}
                                    </li>
                                    <li>
                                        {t("menu.listing_manager_info.bullet_3")}
                                    </li>
                                </ul>
                            </div>
                            <div className="grid grid-cols-3 gap-2 my-3">
                                <img
                                    src="/assets/google.webp"
                                    className="col-span-1"
                                />
                                <img
                                    src="/assets/facebook.webp"
                                    className="col-span-1"
                                />
                                <img
                                    src="/assets/tripadvisor.webp"
                                    className="col-span-1"
                                />
                            </div>
                            <div>
                                <PrimaryButton
                                    variant="strike"
                                    disabled={!hasFeature("LISTING_MANAGER")}
                                    onClick={() => setShowCreateVenue(true)}
                                    fullWidthOnMobile
                                >
                                    {t("menu.listing_manager_info.setup_button")}
                                </PrimaryButton>
                            </div>
                            {!hasFeature("LISTING_MANAGER") && (
                                <div className='mt-3'>
                                    <Alert severity='warning' variant="filled">
                                        {t("menu.listing_manager_info.pro_warning")}
                                    </Alert>
                                </div>
                            )}
                        </div>
                        <div className="md:mb-0 mb-5">
                            <img
                                src="/assets/mozrest-listing.webp"
                                className="col-span-1"
                            />
                        </div>
                    </div>
                </div>
            </PageContainer>
            <>
                <ResponsiveModal
                    open={showCreateVenue}
                    handleClose={() => setShowCreateVenue(false)}
                >
                    <CreateVenueForm onCreated={onCreated} />
                </ResponsiveModal>
            </>
        </>
    )
}

export default MozrestInfo